var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    alt: "social icon for Flow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00EF8B",
    d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.28 11.23h-5.09c-.93 0-1.7.77-1.7 1.7v.57H14v-.57c0-3.43 2.78-6.21 6.2-6.21h5.09v4.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.5 18.02v1.7a6.21 6.21 0 1 1-6.21-6.22h1.7v4.52h4.5Zm-4.52 1.7c0 .92-.76 1.69-1.7 1.69a1.7 1.7 0 0 1-1.69-1.7c0-.93.77-1.7 1.7-1.7h1.7v1.7Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 18.02V13.5H23v4.52h-4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.8cd0e2382046e78cb977e8bbcb643c2b.svg";
export { ForwardRef as ReactComponent };